import React, { createContext, useState, useContext } from 'react';

export const UploadContext = createContext();

export const useUpload = () => {
    return useContext(UploadContext);
};

export const UploadProvider = ({ children }) => {
    const [uploadData, setUploadData] = useState(null);
    const [uploadStatus, setUploadStatus] = useState({
        status: 'idle', // idle, uploading, success, error
        progress: 0,
        total: 0,
        successCount: 0,
        failCount: 0,
        failures: [],
    });

    const startUpload = (data) => {
        setUploadData(data);
        setUploadStatus({
            status: 'uploading',
            progress: 0,
            total: data.listDownload.length,
            successCount: 0,
            failCount: 0,
            failures: [],
        });
    };
    
    const value = {
        uploadData,
        setUploadData,
        uploadStatus,
        setUploadStatus,
        startUpload,
    };

    return (
        <UploadContext.Provider value={value}>
            {children}
        </UploadContext.Provider>
    );
};
